export default "__VITE_ASSET__B3OuT0ea__"